import React from 'react';
import { ErrorPage } from 'utils';
import * as Logger from 'utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Logger.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="l-main-content-outer">
          <main role="main" className="l-main-content">
            <ErrorPage status="genericFrontendError" />
          </main>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
